import { render, staticRenderFns } from "./participant-details.vue?vue&type=template&id=f4aa1a3c&scoped=true"
import script from "./participant-details.vue?vue&type=script&lang=js"
export * from "./participant-details.vue?vue&type=script&lang=js"
import style0 from "./participant-details.vue?vue&type=style&index=0&id=f4aa1a3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4aa1a3c",
  null
  
)

export default component.exports